import React, { useEffect, useRef, useState } from 'react'
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import PlusIcon from '@mui/icons-material/Add';
import FactoryIcon from '@mui/icons-material/Factory';
import axios from 'axios';
import { baseUrl, path } from '../../constants';
import VideoJS from './VideoJS';
import { Oval } from 'react-loader-spinner';
import CancelIcon from '@mui/icons-material/Cancel';
import { api } from '../../api';
import { useContext } from 'react';
import { appContext } from '../../Context/appProvider';
import Player from '../../HulluWare/Player';
import { UploadItem } from './AddCourse';

export default function SubSection({ sectionId, setSelectedSubSection }) {
    const [loaded, setLoaded] = useState(null)
    const [descLoading, setDescLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const fileRef = useRef()
    const thumbRef = useRef()
    const [source, setSource] = useState(null)
    const [description, setDescription] = useState('')
    const {setNotification} = useContext(appContext)
    const [files, setFiles] = useState([])
    const [uploading, setUploading] = useState(false)
    const [thumbnail, setThumbnail] = useState()
    const [queued, setQueued] = useState(false)

    const uploadImage = (event) => {
        setFiles([event.target.files[0]])
     }

    useEffect(() => {
        api(path.subSection + '/' + sectionId?.id).then(response => {
            const data = response.data
            let subSection = data.subSection
            console.log(subSection)
            if(data.success){
                setQueued(subSection.queued)
                setDescription(subSection.description)
                setThumbnail(subSection.thumbnail)
                if(!subSection.queued && subSection.stream){
                    setSource({
                        url: baseUrl + subSection.stream,
                        // label: s.type,
                        type: 'application/x-mpegURL',
                        previewThumbnail: subSection.previewThumbnail,
                        thumbnail: subSection.thumbnail,
                        values: subSection.coursesectionId
                    })
                    setLoaded(true)
                } else {
                    setLoaded(false)
                }
            }
        })
    }, [])
    
    const uploadStream = (file) => {
        if(!file) return alert('file must be selected.')
        setLoaded(false)
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        api(path.uploadStreamFile + '/' + sectionId?.id, {
            data: form,
            method: 'post',
            onUploadProgress: progressEvent => {
                let prog = progressEvent.loaded / progressEvent.total
                console.log(prog)
                setProgress(prog * 100)
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                let data = response.data.subsection
                // setLoaded(true)
                setQueued(true)
                setProgress(null)
                // setSource({
                //     url: baseUrl + data.stream,
                //     type: 'application/x-mpegURL',
                //     previewThumbnail: data.previewThumbnail,
                //     thumbnail: data.thumbnail,
                //     values: data.coursesectionId
                // })
                // setThumbnail(response.data.thumbnail)
            }
        }).catch(e => {
            alert(e)
            setProgress(0)
        })
    }


    const saveSubsection = () => {
        setDescLoading(true)
        api.patch(path.subSection + '/' + sectionId?.id, {
            description,
            thumbnail
        }).then((response) => {
            let data = response.data
            if(data.success){
                setNotification({
                    message: 'Subsection Saved!',
                    visible: true,
                    type: 'success'
                })
            }
        }).finally(() => setDescLoading(false))
    }

  return (
    <div className='fixed inset-0 bg-[#00000070] z-[999999] flex justify-center items-center'>
        <div className='flex justify-center bg-white w-[70%] max-md:w-[90%] relative rounded-md gap-5 p-5 flex-col'>
            <h1 className='self-center font-bold text-[19px] uppercase'>Section: <span className='text-[#ff0000]'>{sectionId?.title}</span></h1>
            <div className='flex flex-1 gap-5 items-center p-5 justify-between max-md:flex-col'>
                <div className='flex flex-col gap-4'>
                    <textarea value={description} onChange={e => setDescription(e.target.value)} cols="30" rows="7" placeholder='Description about this section' className='border-[1px] border-[#00000070] p-4 rounded-md h-fit'>
                    </textarea>
                    <div className='flex gap-4 items-center'>
                        <div className='w-[70px] h-[70px] border-[1px] border-[#00000060] border-dashed flex items-center justify-center flex-col cursor-pointer' onClick={e => thumbRef.current.click()}>
                            <p className='text-[10px]'>{thumbnail ? 'Change' : 'Thumbnail'}</p>
                            <p className='text-[10px]'> (16:9)</p>
                            {!thumbnail && <PlusIcon>Filled</PlusIcon>}
                            <input onChange={event => uploadImage(event)} type='file' ref={thumbRef} hidden />
                        </div>
                        {files.map(file => (
                            <UploadItem file={file} setUploading={setUploading} setSources={setThumbnail} />
                        ))}
                        {!files.length && thumbnail &&  <img src={baseUrl + thumbnail} alt='source' className='w-[70px] h-[70px] object-contain'  />}
                    </div>
                    <p className='text-[12px]'>Thumbnail image <span className='text-[#ff0000]'>(Optional)</span> attracts users to tune in on your course</p>
                    <button onClick={saveSubsection} disabled={!description}  className='outline-none border-none bg-main px-5 py-2 text-[17px] rounded-sm text-white flex justify-center'>
                        { descLoading ? (
                            <Oval
                                visible={true}
                                height="20"
                                width="20"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Save Changes' }
                    </button>
                </div>
                <div className='flex-1 flex flex-col gap-4 items-center justify-center overflow-hidden' style={{
                    width: '100%',
                    maxWidth: '960px',
                    aspectRatio: '16 / 9',
                    border: '1px solid #00000070',
                    borderRadius: '10px'
                }}>
                    { queued &&
                    (<div className='flex flex-col gap-2 items-center'>
                        <div className='flex items-center gap-4'>
                            <FactoryIcon style={{fontSize: 60, color: '#000000'}}>Filled</FactoryIcon>
                            
                        </div>
                        <p className='text-black font-bold text-[15px]'>Video is being transcoded, check after few moments</p>
                    </div>
                    ) }
                    <input onChange={event => uploadStream(event.target.files[0])} type='file' ref={fileRef} hidden />
                    {loaded == false && !queued && 
                    [<div className='flex flex-col gap-2 items-center'>
                        <VideocamOffIcon style={{fontSize: 60, color: '#000000'}}>Filled</VideocamOffIcon>
                        <p className='text-black text-center font-bold text-[17px] max-md:text-xs'>No video is found for this course sub-section. Upload here</p>
                    </div>,
                    <button disabled={progress != 0} onClick={() => fileRef.current.click()} className='outline-none border-none bg-main px-5 py-2 text-[17px] max-md:text-xs rounded-sm text-white'>
                    {progress == 0 ? 'Upload Video' : progress == 100 ? 'Transcode on Progress...' :  `Uploading Video ${progress.toFixed(2)}%`}
                    </button>
                    ]}
                    {loaded == null && (
                            <div className='flex flex-col gap-3 flex-1 items-center justify-center'>
                                <p className='text-[16px]'>Loading section...</p>
                                <Oval
                                    visible={true}
                                    height="30"
                                    width="30"
                                    color="#198754"
                                    ariaLabel="oval-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    strokeWidth={3}
                                />
                            </div>
                    )}
                    {loaded && !queued && <Player options={{source}} style={{}} /> }
                    {/* {progress == true && <p className='text-main bg-[#c0faba] px-8 py-2 text-[13px] font-bold'>Video successfully transcoded.</p>} */}
                    <button onClick={() => setSelectedSubSection(null)} className='absolute outline-none bg-white rounded-full bg-none -top-4 -right-4'>
                        <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
                    </button>                    
                </div>
            </div>
            {loaded != false && <button disabled={progress != 0} onClick={() => fileRef.current.click()} className='outline-none border-[2px] border-main bg-none px-5 py-2 text-[18px] rounded-sm text-main font-bold mt-auto mb-4'>Re-Upload Video</button>}
        </div>
    </div>
  )
}
